<template>
  <div>
    <div id="top-banner" v-if="noticeFlag">
      <img
        src="../assets/notice_finger.png"
        id="top-banner-icon"
      />如需联系客服请点击左上角&lt;返回&gt;至客服中心
    </div>
    <div id="body" :class="{ body: noChangePro, body1: lqaxxzPro }">
      <div :class="{lqawrap:lqaxxzPro}">
        <div class="container" :class="{container1:lqaxxzPro}">
          <div class="title">
            <span class="must">*</span><span class="main-title">反馈类型</span
            ><span class="subtitle">（必选）</span>
          </div>
          <div class="feedback-type-container" :class={lqaftc:lqaxxzPro}>
            <div
              class="feedback-type"
              v-for="(item, index) in allFeedbackTypes"
              :key="index"
            >
              <input
                v-model="feedback_type"
                :value="item"
                name="feedback_type"
                type="radio"
                :id="'type' + index"
              /><label :for="'type' + index"
                ><div :class="`bg_${platformInfo.skin}`"></div>
                {{ item }}</label
              >
            </div>
          </div>
        </div>
        <div class="container" :class="{container1:lqaxxzPro}">
          <div class="title">
            <span class="must">*</span><span class="main-title">建议描述</span
            ><span class="subtitle">（必填，10到300字）</span>
          </div>
          <div style="position: relative" :class="{editor1:lqaxxzPro}">
            <textarea
              placeholder="请填写至少10个字的描述，上传相关截图更有助于您的问题尽快解决呦～"
              v-model="advice"
              class="editor"
              id="textarea"
              maxlength="300"
            ></textarea>
            <div class="textarea-count">{{ advice.length }}/300</div>
          </div>
        </div>
        <div class="container" :class="{container1:lqaxxzPro,pl16:lqaxxzPro}">
          <div class="title">
            <span class="main-title">上传图片</span
            ><span class="subtitle">（可选，不超过4张）</span>
          </div>
          <div class="picked-images-container">
            <input
              type="file"
              ref="imageLoader"
              multiple="multiple"
              v-show="false"
              @change="showImage"
              accept="image/*"
            />
            <div
              v-for="(item, index) in pickedImage"
              :key="index"
              class="picked-image"
			  :class="{picked_image_lqa:lqaxxzPro}"
              :style="{ backgroundImage: 'url(' + item + ')' }"
            >
              <img
                src="../assets/icon_del.png"
                class="delete"
                @click="deleteImage(index)"
              />
            </div>
            <div
              class="picked-image"
			  :class="{picked_image_lqa:lqaxxzPro}"
              v-show="pickedImage.length < 4"
              @click="addImage()"
            >
              <img src="../assets/address_add.png" id="add" />
            </div>
          </div>
        </div>
        <div class="container" :class="{pl16:lqaxxzPro}">
          <div class="title">
            <span class="main-title">联系方式</span
            ><span class="subtitle">（可选，仅工作人员可见）</span>
          </div>
          <div :class="{editor1:lqaxxzPro}">
            <input
              class="editor"
              placeholder="如需得到反馈，请留下您的联系方式"
              v-model="contract"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="button-container" :class="{ btnwrapcls: lqaxxzPro }">
      <div
        id="button"
        :class="`bg_${platformInfo.skin} br_${platformInfo.skin}`"
        @click="submit"
      >
        {{ btnTxt }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { toBase64, dataURLtoFile } from "@/utils/utils";
import { MessageBox, Toast } from "mint-ui";
export default {
  data() {
    return {
      pickedImage: [],
      pickedFile: [],
      advice: "",
      count: 0,
      contract: "",
      isIos: /iphone|ipad|ipod|ios/i.test(navigator.userAgent),
      allFeedbackTypes: [],
      feedback_type: "",
    };
  },
  watch: {
    advice(val) {
      this.advice = val;
    },
    contract(val) {
      this.contract = val;
    },
  },
  computed: {
    ...mapState(["platformInfo"]),
    lqaxxzPro({ platformInfo }) {
      //乐其爱形象照样式
      return platformInfo.skin === "skin8";
    },
    noChangePro({ lqaxxzPro }) {
      return !lqaxxzPro;
    },
    noticeFlag({ noChangePro }) {
      return noChangePro;
    },
    btnTxt({ lqaxxzPro }) {
      return lqaxxzPro ? "立即反馈" : "确定提交";
    },
  },
  methods: {
    ...mapActions([
      "sendFeedback",
      "getfeedbackType",
      "getOssImageKeyM",
      "font_testM",
    ]),
    showImage(e) {
      let fileArr = Array.from(e.target.files);
      console.log(fileArr);
      let len_left = 4 - this.pickedImage.length;
      let len = fileArr.length > len_left ? len_left : fileArr.length;
      if (fileArr.length > len_left) {
        Toast("图片只能传4张哟~");
      }
      for (let i = 0; i < len; i++) {
        console.log(fileArr[i].type);
        if (fileArr[i].type.indexOf("image") != -1) {
          let url = null;
          if (window.createObjectURL != undefined) {
            url = window.createObjectURL(fileArr[i]);
          } else if (window.URL != undefined) {
            url = window.URL.createObjectURL(fileArr[i]);
          } else if (window.webkitURL != undefined) {
            url = window.webkitURL.createObjectURL(fileArr[i]);
          }
          toBase64(fileArr[i], (res) => {
            let picName = this.count + ".jpg";
            let obj = [res.base64_remove_head, picName];
            return this.getOssImageKeyM(fileArr[i]).then((res) => {
              this.pickedImage.push(url);
              this.count++;

              this.pickedFile.push(obj);
              this.$refs.imageLoader.value = "";
            });
            // console.log(obj)
          });
        } else {
          Toast("请不要传入非图片类型的文件");
        }
      }
    },
    addImage() {
      let { platform } = this.platformInfo;
      //微信就用jssdk
      if (platform === "wechat") {
        this.sdk.feedbackphotos().then((res) => {
          for (let i = 0, len = res.length; i < len; i++) {
            if (this.pickedImage.length >= 4) {
              Toast("图片只能传4张哟~");
              break;
            }
            let { loid, url } = res[i];
            let baseStr = url.replace(/^.*base64,/, "");
            this.count++;
            // console.log(url)
            let picName = this.count + ".jpg";
            let obj = [baseStr, picName];
            this.getOssImageKeyM(dataURLtoFile(url, picName)).then((res) => {
              this.pickedFile.push(obj);
              this.isIos
                ? this.pickedImage.push(url)
                : this.pickedImage.push(loid);
            });
          }
        });
      } else {
        this.$refs.imageLoader.click();
      }
    },
    deleteImage(e) {
      console.log(e);
      this.pickedImage.splice(e, 1);
      this.pickedFile.splice(e, 1);
    },
    checkPhone() {
      return new Promise((resolve, reject) => {
        if (!this.contract) {
          //二次提示
          MessageBox({
            title: "提示",
            message: "如需得到反馈，请留下您的联系方式手机号/邮箱",
            showCancelButton: true,
            confirmButtonText: "需要",
            cancelButtonText: "不需要",
          }).then((res) => {
            if (res === "cancel") {
              return resolve();
            } else {
              return reject();
            }
          });
        } else {
          resolve();
        }
      });
    },
    submit() {
      if (this.check()) {
        this.checkPhone().then((res) => {
          let { contract, advice } = this;
          this.font_testM(contract + advice).then((res) => {
            this.sendFeedback({
              facility: this.platformInfo.brand,
              applet_version: this.platformInfo.version,
              telephone: contract,
              feedback_type: this.feedback_type,
              feedback_content: advice,
              files: this.pickedFile,
            }).then((res) => {
              console.log(res);
              MessageBox.alert(
                "您的意见会发到我们工作人员的邮箱，感谢您的反馈",
                "提交成功"
              );
              this.reset();
            });
          });
        });
      }
    },
    reset() {
      this.pickedImage = [];
      this.pickedFile = [];
      this.advice = "";
      this.count = 0;
      this.contract = "";
      this.feedback_type = this.allFeedbackTypes[0];
    },
    check() {
      if (this.contract) {
        if (!/^[^\u4e00-\u9fa5]*$/.test(this.contract)) {
          MessageBox.alert("请输入电子邮件或QQ号或手机号", "提交失败");
          return false;
        }
      }
      if (this.advice.length < 10) {
        MessageBox.alert("请至少输入10个字的建议描述", "提交失败");
        return false;
      }
      return true;
    },
  },
  created() {
    console.log(this.platformInfo.brand, this.platformInfo.version);
    this.getfeedbackType().then((res) => {
      console.log(res);
      this.allFeedbackTypes = res.data;
      this.feedback_type = res.data[0];
    });
  },
};
</script>

<style scoped="scoped">
#top-banner {
  width: 3.75rem;
  height: 0.42rem;
  background: rgba(255, 249, 240, 1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  padding: 0 0.28rem;
  font-size: 0.13rem;
  color: rgba(245, 166, 35, 1);
  line-height: 0.18rem;
  display: flex;
  align-items: center;
}
#top-banner-icon {
  width: 0.2rem;
  height: 0.24rem;
}
#body {
  box-sizing: border-box;
}
.body {
  padding: 0.4rem 0.15rem 1rem 0.15rem;
}
.body1 {
  padding: 0.16rem 0.16rem 1.4rem 0.16rem;
}
.container {
  margin-top: 0.2rem;
}
.title {
  margin-left: 0.05rem;
}
.main-title {
  font-size: 0.18rem;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
}
.subtitle {
  font-size: 0.13rem;
  color: rgba(153, 153, 153, 1);
}
.must {
  color: red;
  font-size: 0.2rem;
  margin-right: 0.05rem;
}
.editor {
  border: none;
  margin-top: 0.15rem;
  padding: 0.2rem 0.15rem;
  width: 3.45rem;
  border-radius: 0.06rem;
  font-size: 0.13rem;
}
#textarea {
  resize: none;
  height: 1.45rem;
}
.textarea-count {
  position: absolute;
  bottom: 0.12rem;
  right: 0.15rem;
  font-size: 0.13rem;
  color: rgba(153, 153, 153, 1);
}
.picked-images-container {
  width: 3.45rem;
  height: 1rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-top: 0.15rem;
}
.picked-image {
  width: 0.8rem;
  height: 0.8rem;
  flex-shrink: 0;
  margin-right: 0.08rem;
  display: inline-flex;
  border-radius: 0.04rem;
  justify-content: center;
  position: relative;
  align-items: center;
  background-color: #ffffff;
  overflow: visible;
  background-size: cover;
}
.image {
  max-width: 0.8rem;
  max-height: 0.8rem;
  overflow: hidden;
}
#add {
  width: 0.12rem;
}
.pl16 #add{
	width:.2rem;
}
.delete {
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  top: -0.08rem;
  right: -0.08rem;
}
#button {
  width: 94.667vw;
  height: 0.45rem;
  /* background:rgba(68,128,231,1); */
  box-shadow: 0px 0.05rem 0.1rem 0px rgba(68, 128, 231, 0.25);
  border-radius: 0.225rem;
  line-height: 0.45rem;
  color: white;
  font-size: 0.16rem;
  text-align: center;
  margin-left: 2.4vw;
}
input[type="radio"] {
  display: none;
}
input[type="radio"] + label {
  font-size: 0.14rem;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-right: 0.16rem;
  margin-top: 0.15rem;
  display: flex;
  align-items: center;
}
input[type="radio"]:not(:checked) + label > div {
  background-color: inherit;
  background-image: url("../assets/unselect-radio2.png");
  background-position: 0 0;
  background-size: 100% 100%;
  border-radius: 50%;
  width: 0.16rem;
  height: 0.16rem;
  content: "";
  display: inline-block;
  margin-right: 0.05rem;
  flex-shrink: 0;
}
input[type="radio"]:checked + label > div {
  background-image: url("../assets/selected-radio2.png");
  background-position: 0.015rem 0.04rem;
  background-size: 0.12rem 0.09rem;
  background-repeat: no-repeat;
  border-radius: 50%;
  width: 0.16rem;
  height: 0.16rem;
  content: "";
  display: inline-block;
  margin-right: 0.05rem;
  flex-shrink: 0;
}
.feedback-type {
  display: inline-block;
}
.lqawrap{
	box-sizing: border-box;
	background-color: #fff;
	overflow: hidden;
	border-radius: .08rem;
	padding-bottom: .2rem;
}
.lqaftc{
	padding:0 .16rem 0;
	box-sizing: border-box;
}
.editor1{
	box-sizing: border-box;
	margin: 0.15rem .16rem 0;
	background-color: #F5F6FA;
}
.editor1 .editor{
	margin-top: 0;
	width: 100%;
	background-color: #F5F6FA;
}
.picked_image_lqa{
	background-color: #F5F6FA;
}
.container1{
	border-bottom: .01rem solid #F5F6FA;
	padding-bottom: .2rem;
}
.pl16{
	padding-left: .16rem;
}
.pl16 .title{
	margin-left: 0;
}
.pl16 .editor1{
	margin-left: 0;
}
.btnwrapcls {
  box-sizing: border-box;
  height: 1.24rem;
  align-items: flex-start;
  padding-top: 0.23rem;
}
</style>
